import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { LetterRequestCustomer_ScheduleTable2_Interface } from 'src/app/Interface/LetterRequestCustomer_ScheduleTable2_Interface';
import { Empty_LetterRequestCustomer_ScheduleTable_Co_Interface, LetterRequestCustomer_ScheduleTable_Co_Interface } from 'src/app/Interface/LetterRequestCustomer_ScheduleTable_Co_Interface';
import { Empty_LetterRequestCustomer_ScheduleTable_Interface, LetterRequestCustomer_ScheduleTable_Interface } from 'src/app/Interface/LetterRequestCustomer_ScheduleTable_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { GeneralService } from 'src/app/Service/General/General.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-LetterRequestCustomerSchedule',
  templateUrl: './LetterRequestCustomerSchedule.component.html',
  styleUrls: ['./LetterRequestCustomerSchedule.component.scss']
})
export class LetterRequestCustomerScheduleComponent implements OnInit {
  Filter_customer: String = ''
  StartSearchDate: String = ''
  EndSearchDate: String = ''
  showUnSchedule:String='1'
  Procssing: boolean = false
  BaseUrl = environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="

  Show_Draft_LetterRequestCustomer:string="0"

  constructor(
    private Nav_Service: NavService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private General_Service: GeneralService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Procssing = true
    this.BaseUrl=environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="
    this.Nav_Service.CheckValidPage(1123).subscribe(
      data => {

        this.General_Service.GetPeriod().subscribe(
          data2=>{
            this.startMonth=data2['startMonth']
            this.endMonth=data2['endMonth']

            this.start15=data2['start15']
            this.end15=data2['end15']

            this.startWeek=data2['startWeek']
            this.endWeek=data2['endWeek']

            this.today = data2['today']
            this.Procssing = false
          }
        )

      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#region Period

  ExpertCalibration:String=''

  startMonth: String = ''
  endMonth: String = ''

  start15: String = ''
  end15: String = ''

  startWeek: String = ''
  endWeek: String = ''

  today: String = ''



  ReadData_Month()
  {
    this.ReadData_Schedule(this.startMonth,this.endMonth)
  }

  ReadData_Week()
  {
    this.ReadData_Schedule(this.startWeek,this.endWeek)
  }

  ReadData_15()
  {
    this.ReadData_Schedule(this.start15,this.end15)
  }

  ReadData_today()
  {
    this.ReadData_Schedule(this.today,this.today)
  }

  //#endregion

  ExpertCalibration_Type:number=0
  canScheduling:boolean=false
  canSchedulingPDF:boolean=false
  DataList_Schedule: Array<LetterRequestCustomer_ScheduleTable_Interface> = []
  DataList_Schedule_2: Array<LetterRequestCustomer_ScheduleTable2_Interface> = []
  DataList_User: Array<General_Interface> = []

  //DataList_Schedule_Expert:Array<any>=[]
  DataList_Schedule_Expert_Uniq:Array<any>=[]
  DataList_Schedule_Expert_Uniq_Color:Array<any>=[]
  ReadData_Schedule(StartSearchDate, EndSearchDate) {
    this.Procssing = true
    this.DataList_Schedule = []
    this.StartSearchDate = StartSearchDate
    this.EndSearchDate = EndSearchDate
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerSchedule(
      this.StartSearchDate,
      this.EndSearchDate,
      this.Filter_customer,
      this.ExpertCalibration,
      this.showUnSchedule == '1',
      this.ExpertCalibration_Type).subscribe(
      data => {
        this.DataList_Schedule = data['result']
        //this.DataList_Schedule_Expert = data['expert']

        this.DataList_Schedule_2=data['result2']
        this.DataList_Schedule_Expert_Uniq = data['expert1']
        this.DataList_Schedule_Expert_Uniq_Color = data['expert1_color']
        this.canScheduling = data['canScheduling']
        this.canSchedulingPDF = data['canSchedulingPDF']
        this.DataList_User = data['experts']
        this.Procssing = false

      }
    )
  }

  Change_Visible_Expert(item:LetterRequestCustomer_ScheduleTable_Co_Interface) {
    item.expert_Visible=!item.expert_Visible
  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaSchedule.xlsx");

  }

  exportexcelExpert(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table-Expert');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaSchedule.xlsx");

  }


  Selected_ScheduleTable_Record:LetterRequestCustomer_ScheduleTable_Interface=Empty_LetterRequestCustomer_ScheduleTable_Interface()
  WindowsSwitcher_Indexer:string='List'

  BackToList(){
    this.WindowsSwitcher_Indexer='List'
  }

  setSchuduleForProgramming(item:LetterRequestCustomer_ScheduleTable_Interface)
  {
    if(item.canProgamming==false)
    {
      this.Alertify_Service.ErrorMessage("امکان برنامه ریزی برای تاریخ مورد نظر، نیست!")
    }
    else{
      this.Selected_ScheduleTable_Record=item
      this.WindowsSwitcher_Indexer='Form'
    }
  }


  OnGet_ExpertCalibration_Action(model: Array<ExpertCalibration_Interface>)
  {
    this.ExpertCalibration = "-1"
    for (let item of model)
    {
      this.ExpertCalibration=this.ExpertCalibration+","+item.id
    }

    if (model.length == 0)
      this.ExpertCalibration=""

  }



  ImageAttachFile_List: Array<string> = []
  BaseUrl2 = environment.BaseUrl
  modalRef_FileAttach: any
  Selected_Schedule__FileAttach:LetterRequestCustomer_ScheduleTable_Co_Interface=Empty_LetterRequestCustomer_ScheduleTable_Co_Interface()
  openModalFileAttach(template: TemplateRef<any>,item:LetterRequestCustomer_ScheduleTable_Co_Interface) {
    this.modalRef_FileAttach = this.modalService.show(template);
    this.Selected_Schedule__FileAttach = item
    this.ImageAttachFile_List=item.file
  }









  //#region Scheduling

  Schedule_Persian_Date:string=''
  Schedule_Expert_Title:String=''
  Schedule_Expert_Id:number=0
  OnSet_Scheduling(id: number,inputDate:string)
  {
    if (this.canScheduling)
    {
      this.Schedule_Persian_Date=inputDate
      this.Schedule_Expert_Title=this.DataList_User[id].title
      this.Schedule_Expert_Id = this.DataList_User[id].id
      this.WindowsSwitcher_Indexer='Schedule'
    }
  }


  //#endregion

}
